export default {
  data: function () {
    return {
      activeFields: []
    }
  },
  created: function () {
    let fields = document.getElementsByClassName('form-control')
    for (let i = 0; i < fields.length; i++) {
      let name = fields[i].getAttribute('name')
      if (this.form.fields[name]) {
        this.addActive(name)
      }
    }
  },
  methods: {
    addActive (name) {
      if (!this.checkActive(name)) {
        this.activeFields.push(name)
      }
    },
    checkActive (name) {
      if (this.activeFields.indexOf(name) > -1) {
        return true
      }
      return false
    },
    checkInput (name) {
      if (this.form.fields[name] && this.form.fields[name].length > 0) {
        this.addActive(name)
      }
      this.form.errors.clear(name)
    },
    removeActive (name) {
      if (!this.form.fields[name] || (this.form.fields[name] && this.form.fields[name].length === 0)) {
        this.activeFields.splice(this.activeFields.indexOf(name), 1)
      }
    },
    removeAllActiveFields () {
      this.activeFields = []
    }
  }
}